import { useTheme } from '../context/ThemeContext';
import { useTenant } from '../context/TenantContext';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button className="btn" onClick={toggle} aria-label="Toggle theme" title={theme === 'light' ? 'Switch to dark' : 'Switch to light'}>
      {theme === 'light' ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      )}
    </button>
  );
}

export function BrandMark({ size = 32 }: { size?: number }) {
  const { branding } = useTenant();
  if (branding?.logoUrl) {
    return <img src={branding.logoUrl} alt={branding.name} style={{ height: size, borderRadius: 6 }} />;
  }
  // fallback: monogram tile in the tenant's brand colour
  const initials = (branding?.name ?? 'E').split(' ').slice(0, 2).map((w) => w[0]).join('').toUpperCase();
  return (
    <div style={{
      width: size, height: size, borderRadius: 8, background: 'var(--brand)',
      color: '#fff', display: 'grid', placeItems: 'center',
      fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: size * 0.42,
    }}>
      {initials}
    </div>
  );
}

export function StatusPill({ status }: { status: string }) {
  const map: Record<string, string> = {
    Paid: 'pill-ok', Active: 'pill-ok',
    Pending: 'pill-warn', PartiallyPaid: 'pill-warn',
    Cancelled: 'pill-danger', Withdrawn: 'pill-danger', Inactive: 'pill-muted', Alumni: 'pill-muted',
  };
  const label: Record<string, string> = { PartiallyPaid: 'Partly paid' };
  return <span className={`pill ${map[status] ?? 'pill-muted'}`}>{label[status] ?? status}</span>;
}
